import { Box, keyframes } from '@mui/material';

const typingAnimation = keyframes`
  0%, 60%, 100% {
    transform: translateY(0px);
    opacity: 0.5;
  }
  30% {
    transform: translateY(0.2rem);
    opacity: 1;
  }
`;

const styles = {
  typingDots: {
    display: 'flex',
    alignItems: 'center',
    gap: (theme) => theme.spacing(0.25),
    padding: (theme) => theme.spacing(1, 1.5),
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: (theme) => theme.palette.baseColors.deepSeaNavy.c100,
    animation: `${typingAnimation} 1.4s infinite ease-in-out`,
    '&:nth-of-type(1)': {
      animationDelay: '0ms',
    },
    '&:nth-of-type(2)': {
      animationDelay: '160ms',
    },
    '&:nth-of-type(3)': {
      animationDelay: '320ms',
    },
  },
};

export const TypingIndicator = () => (
  <Box sx={styles.typingDots}>
    <Box sx={styles.dot} />
    <Box sx={styles.dot} />
    <Box sx={styles.dot} />
  </Box>
);
